import { ref } from 'vue';
import { useOneOffTaskInput, type OneOffTaskInputPayload } from '@/components/shared/OneOffTaskInput';
import { Api } from '@/api';

export const useMeetingStageSheetTasks = () => {
  const taskInput = useOneOffTaskInput();
  const tasks = ref<OneOffTaskInputPayload[]>([]);

  const addTask = () => {
    if (!taskInput.validate()) return;
    tasks.value.push(taskInput.toPayload());
    taskInput.reset();
    taskInput.expand();
  };

  const removeTask = (index: number) => {
    tasks.value.splice(index, 1);
  };

  const collectAllTasks = (): OneOffTaskInputPayload[] => {
    const allTasks = [...tasks.value];

    if (taskInput.taskName.value.trim()) {
      allTasks.push(taskInput.toPayload());
    }

    return allTasks;
  };

  const validateTasks = (): boolean => {
    if (taskInput.taskName.value.trim() && !taskInput.validate()) return false;
    return true;
  };

  const submitAllTasks = async (contactId: number): Promise<void> => {
    const allTasks = collectAllTasks();
    await Promise.all(allTasks.map(task => Api.OneOffTaskAssignments.createOneOfTaskAssignment(contactId, task)));
  };

  return {
    taskInput,
    tasks,
    addTask,
    removeTask,
    validateTasks,
    submitAllTasks,
  };
};

export type UseMeetingStageSheetTasksReturn = ReturnType<typeof useMeetingStageSheetTasks>;
